/**
 * 팝업의 「전체 내역 보기」 링크 해소 — **라벨은 서버가, 목적지는 앱이 소유한다**(ⓑ · 2026-10-26).
 *
 * ## 계약 — 세 갈래이고 구분자는 «`linkUrl`의 null 여부»다
 *
 * | 응답 | 뜻 | 목적지 |
 * |---|---|---|
 * | `linkUrl` 있음 | **운영자가 만든 공지** — 사람이 실제 주소를 적었다 | 그 주소 그대로 |
 * | `linkUrl` 없고 `linkLabel`만 | **자동 생성된 업데이트 묶음** — 트리거가 url을 null로 둔다 | **앱이 주입한 목적지** |
 * | 둘 다 없음 | 링크가 없는 공지 | 링크를 그리지 않는다 |
 *
 * ## ⛔ 첫 갈래는 «오늘 도달 불가»다 — 지우지 말고 그 사실을 읽어라
 *
 * 오늘 `linkUrl`이 차 있는 팝업은 **0건**이다 — 트리거는 그 칸을 null로 두고, **저작 DTO가 그
 * 칸을 아예 받지 않는다**(`apps/server/src/popups/dto/popup.dto.ts` 전수 측정 · 2026-10-26:
 * 받는 칸은 `title`·`body`·`platforms`·`audiences`·`frequency`·`startsAt`·`endsAt`·`publish`·
 * `hidden`이고 `linkLabel`·`linkUrl`은 **0건**. **[대조군]** 같은 needle이 `popups/` 안 다른
 * 자리를 4건 잡아 계측기 생존 확인). 즉 **「운영자 커스텀 링크」가 존재할 수 없다.**
 *
 * ⚠️ 그래도 이 갈래를 **지우지 않는다** — 저작이 그 칸을 받게 되는 날(공지에 링크를 넣는 요구는
 * 자연스럽다) 되돌려야 하고, **도달 불가를 「명시」하면 거짓 안심이 아니다.**
 * ⛔ **이 갈래의 초록을 「운영자 커스텀 링크가 동작한다」의 근거로 인용하지 말 것** — 그 축의
 * 소유자는 `__tests__/PopupHost.test.tsx`와 이 파일의 짝 spec이 **입력을 직접 먹여 재는**
 * 케이스들이고, 그것이 도달 불가 갈래의 **유일한** 소유자다.
 *
 * ⭐ **그래서 소스 구분자를 새로 만들지 않는다** — 기존 칸의 **null 상태**가 그 일을 한다.
 * `sourceKey`도 `sourceType`도 필요 없고 `popup-consumer-decoupling` 축을 건드리지 않는다.
 *
 * ## 왜 서버 값을 그대로 쓰지 않나 (ⓐ 기각)
 *
 * `linkUrl`은 **한 칸**이고 한 묶음이 `WEB+APP+ADMIN`을 걸치므로 surface별로 가를 수 없다. 그래서
 * 거기 들어가던 값은 **web 라우트**(`/release-notes`)였고, admin에서 그 경로는 소비 화면이 아니라
 * **「업데이트 내역 관리」(`system-settings` 권한)**다 — 그대로 쓰면 **대부분의 운영자를 권한
 * 게이트로 보낸다**. 즉 ⓐ(값을 남기고 앱이 해소)에서도 결국 앱이 해소해야 하므로, ⓐ는 ⓑ와 같은
 * 일을 하면서 **「반드시 무시해야 하는 함정 값」 하나를 더 드는** 선택이었다. ⇒ 트리거가 url을
 * null로 두고 라벨만 싣는다.
 *
 * ## ⚠️ 한계 — 운영자가 라벨만 넣고 주소를 비우면 목적지가 틀린다
 *
 * 그 조합(`linkLabel` 있음 ∧ `linkUrl` 없음)은 위 표에서 **자동 묶음과 구별되지 않으므로** 그
 * 공지도 앱의 업데이트 내역 화면으로 간다. **저작에서 그 조합이 막히면 이 구분자는 완전하다**(그
 * 상태를 트리거만 만들 수 있다) — 저작 불변식 판정은 요청자 쪽이 소유하고 **2026-10-26 기준
 * 미확인**이다. 허용으로 판명되면 처방은 둘이다: 저작에서 금지하거나, 운영자가 **라벨과 주소를
 * 함께** 넣게 안내한다. ⇒ 그 결과가 오면 **이 문단만** 고치면 된다(코드는 그대로다).
 *
 * ## ⚠️ 중복을 제거하는 것이 설계다
 *
 * 같은 제목 팝업은 **한 장으로 합쳐지고**(`groupByTitle`) 그 항목마다 라벨이 있을 수 있다. 자동
 * 묶음 둘이 합쳐지면 라벨도 목적지도 **같으므로** 그대로 그리면 **같은 링크가 두 번** 보인다 —
 * 그것이 합치기의 흔한 경우다(surface 집합만 다른 두 묶음). 그래서 **해소된 (라벨, 목적지) 쌍**으로
 * 중복을 제거한다.
 *
 * ⚠️ **오늘 이 함수가 가진 축은 그 하나다** — 자동 묶음 둘이 합쳐져 같은 링크가 두 번 보이는 것.
 * 「운영자 공지가 서로 **다른** 주소를 들면 각각 남는다」는 **미래 축**이다(위 절대로 그 주소를
 * 넣을 경로가 오늘 없다). 둘을 섞어 읽지 말 것 — 오늘의 소유자와 내일의 값어치는 다른 문장이다.
 *
 * ⛔ **「첫 항목의 것만 쓴다」를 기각한 이유는 «조용한 손실»이고 그것은 오늘도 참이다.** 그 안은
 * 다른 주소를 **red도 로그도 없이** 가려서, 운영자는 자기 링크가 사라진 것을 **모른다.** 지금 쌍
 * 비교가 「과하다」고 느껴져도 단순화하지 말 것 — 가르는 기준은 **「무엇을 잃나」**이고, 쌍 비교는
 * 잃는 것이 없고 첫 항목 안은 잃는 것이 **보이지 않는다.**
 *
 * ## 오늘 실제로 도는 갈래 — 둘째가 «살아 있다» (2026-10-26 갱신)
 *
 * 판정 응답이 그 두 칸을 **내려준다**(`popups.service.ts#listActive`의 `.map`에 `linkLabel`·
 * `linkUrl`이 있다). ⚠️ 종전 이 절은 그 반대를 적고 있었는데 **그 전제가 이웃(서버)에서
 * 바뀌었다** — 낡은 것이 아니라 **뒤집힌** 서술이었다. 지금은:
 *
 * - **둘째 갈래(라벨만 → 앱 목적지)가 실경로다** — 트리거가 `linkLabel`을 채우고 `linkUrl`을
 *   null로 두므로 자동 묶음 팝업에 **링크가 실제로 뜬다.**
 * - **첫째 갈래는 여전히 도달 불가**다(저작 DTO가 `linkUrl`을 안 받는다 — 위 절).
 * - 셋째 갈래는 라벨이 없는 공지(운영자 저작)가 탄다.
 *
 * ⇒ 이 함수의 초록은 이제 **둘째 갈래에 대해서는** 실경로를 재는 것이다. 그래도 **「prod에서 그
 * 링크가 옳은 화면으로 간다」의 근거는 아니다** — 목적지는 앱이 주입하므로 그 축의 소유자는 각
 * 앱의 배선(web `/release-notes` · admin `/release-note-feed`)이다.
 *
 * ⭐ **그 배선 축은 census로 닫혔다** — 재는 법과 [대조군]은 `PopupHost` JSDoc이 정본이고 여기
 * 베껴 적지 않는다. ⛔ **「spec이 못 닫는다」를 「브라우저가 아니면 못 닫는다」로 번역하지 말 것.**
 */

/** 호스트가 링크를 그리는 데 필요한 것만 — 서버 칸 둘(옵셔널) */
export interface PopupLinkSource {
  linkLabel?: string | null;
  linkUrl?: string | null;
}

/** 그릴 링크 한 줄 */
export interface PopupLink {
  label: string;
  href: string;
  /**
   * React key — **중복 제거에 쓴 그 키를 그대로 내보낸다.**
   *
   * ⚠️ `href` 하나를 key로 쓰면 **안 된다** — 중복 제거는 (라벨, 목적지) **쌍**으로 하므로
   * 라벨이 다르고 주소가 같은 두 링크가 **둘 다 남을 수 있다**(운영자 공지 둘이 같은 화면을
   * 다른 문구로 가리키는 경우). 그때 key가 겹치면 React가 DOM을 재사용해 **문구가 섞인다.**
   * 제거에 쓴 키는 쌍 전체이므로 **제거 뒤 유일함이 보장된다** — 그래서 여기서 다시 만들지
   * 않고 그 값을 넘긴다(두 자리가 키를 각자 만들면 어긋난다).
   */
  key: string;
}

/**
 * 장에 든 항목들에서 그릴 링크를 해소한다 — 위 표가 계약이고, 결과는 **중복이 제거된 순서 보존
 * 목록**이다(첫 등장 순서).
 *
 * @param appLinkHref 라벨만 있는 팝업이 갈 **이 앱의** 목적지. 없으면 그 갈래는 링크를 만들지
 *   않는다 — 앱이 목적지를 모르는데 서버 값으로 떨어지면 ⓐ의 함정으로 되돌아간다.
 */
export function resolvePopupLinks(
  items: readonly PopupLinkSource[],
  appLinkHref?: string,
): PopupLink[] {
  const out: PopupLink[] = [];
  const seen = new Set<string>();

  for (const item of items) {
    const label = item.linkLabel?.trim();
    if (!label) continue;

    // `linkUrl`이 있으면 운영자가 적은 주소다 — 그대로 쓴다(커스텀 링크가 죽지 않는다).
    // 없으면 자동 묶음이므로 **앱이 주입한 목적지**로 보낸다.
    // ⛔ 스킴을 거르지 «않는다» — 그 갈래는 오늘 도달 불가라(위 절) 검증이 없어도 무해하지만, 저작이
    //    `linkUrl`을 받게 되는 날 `javascript:` 같은 스킴이 그대로 href가 된다. 그 칸을 열 때 **서버 DTO와
    //    여기 둘 다** 허용 스킴(상대 경로·http(s))을 함께 정할 것(리뷰 1103 F15).
    const href = item.linkUrl?.trim() || appLinkHref;
    if (!href) continue;

    // 라벨과 목적지가 **둘 다** 같을 때만 같은 링크다 — 라벨만 비교하면 서로 다른 주소를 든
    // 운영자 공지 둘 중 하나가 사라진다.
    //
    // ⚠️ 두 값을 구분자로 이어 붙이지 «않는다» — 어떤 구분자를 골라도 그것이 라벨이나 주소 안에
    // 나타나면 서로 다른 쌍이 같은 키가 된다(제어문자 구분자는 이 레포에서 금지이기도 하다).
    // `JSON.stringify`는 배열 경계를 스스로 이스케이프하므로 그 모호가 **구조적으로** 없다.
    const key = JSON.stringify([label, href]);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ label, href, key });
  }

  return out;
}
